import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.FreundschaftsWerbung.EmpfehlungsantragVermerkenRequest
 * Model zum Erhöhen des Zählers zur Anzahl der Empfehlungen in einem Freundschaftswerberdatensatz
 * Endpoints: /api/FreundschaftsWerbung/EmpfehlungsantragVermerken
 */
export class EmpfehlungsantragVermerkenRequestApi extends BaseApiModel {
	constructor(initialProperties?: Partial<EmpfehlungsantragVermerkenRequestApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected empfehlungsId: string;
	/**
	 * Description: Empfehlungs-Id, die zum Erzeugen des langen Empfehlungslink zurückgegeben wurde
	 * APIL Type: string
	 */
	get EmpfehlungsId(): string {
		return this.empfehlungsId;
	}

	/**
	 * Description: Empfehlungs-Id, die zum Erzeugen des langen Empfehlungslink zurückgegeben wurde
	 * APIL Type: string
	 */
	set EmpfehlungsId(value: string) {
		this.empfehlungsId = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): EmpfehlungsantragVermerkenRequestApi {
		return AppUtils.Helper.createFromMap(dataObject, EmpfehlungsantragVermerkenRequestApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.EmpfehlungsId = this.empfehlungsId;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}